module.exports = __webpack_public_path__ + "img/1-kilo-blue.0555f324.svg";